import { render, staticRenderFns } from "./ActionItemList.vue?vue&type=template&id=1089ab8a&scoped=true&"
import script from "./ActionItemList.vue?vue&type=script&lang=js&"
export * from "./ActionItemList.vue?vue&type=script&lang=js&"
import style0 from "./ActionItemList.vue?vue&type=style&index=0&id=1089ab8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089ab8a",
  null
  
)

export default component.exports